import { z } from 'zod';

import {
  sewCustomerPartiesModeSchema,
  sewTenantMetaDataInputSchema,
  validateSewCustomerParties,
} from '@/backoffice/features/tenants/components/onboard-tenant/onboard-tenant-wizard.validation';
import { SEW_CUSTOMER_PARTIES_MODE_FIELD } from '@/reseller/sew/metadata/sew-metadata.constants';
import { optionalString, requiredString } from '@/shared/utils/validation';

// SEW requires the EURODRIVE billing metadata; other resellers don't collect it.
export const getUpdateTenantFormSchema = (isSew?: boolean) =>
  z
    .object({
      ownerId: requiredString(),
      groupId: optionalString(),
      [SEW_CUSTOMER_PARTIES_MODE_FIELD]: sewCustomerPartiesModeSchema,
      metaData: isSew
        ? sewTenantMetaDataInputSchema(true)
        : sewTenantMetaDataInputSchema().optional(),
    })
    .superRefine(validateSewCustomerParties);
